module.exports = __webpack_public_path__ + "static/bg-fd8b021f927ab42f86f9b21d7cd41edd.jpg";